export enum EnrollmentCourseStatusEnum{

    InProgress  = 1,
    Done  = 2,
}
